/// <amd-module name="Wit/BacklogsHub/Common/Services/BacklogLevelWorkItemService" />
import { IVssPageContext, IVssService, Services, VssService } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { DataProviders } from "Wit/BacklogsHub/Common/BacklogHubContants";
import { BacklogLevelWorkItemData } from "Wit/BacklogsHub/Common/Contracts/BacklogsHub.Models";

export interface IBacklogLevelWorkItemService extends IVssService {
    getBacklogLevelWorkItemData(teamId: string, backlogId: string, ignoreCache: boolean): Promise<BacklogLevelWorkItemData | undefined>;
    getBacklogLevelWorkItemDataForIds(teamId: string, backlogId: string, workItemIds: number[]): Promise<BacklogLevelWorkItemData | undefined>;
}

export class BacklogLevelWorkItemService extends VssService implements IBacklogLevelWorkItemService {
    private cachedTeamId: string;
    private cachedBacklogId: string;
    private workItemDataPromise: Promise<BacklogLevelWorkItemData | undefined>;

    public _serviceStart = (pageContext: IVssPageContext): void => {
        super._serviceStart(pageContext);
    };

    public _serviceEnd = (pageContext: IVssPageContext): void => {
        super._serviceEnd(pageContext);
    };

    public getBacklogLevelWorkItemData(teamId: string, backlogId: string, ignoreCache: boolean): Promise<BacklogLevelWorkItemData | undefined> {
        if (ignoreCache || !this.workItemDataPromise || teamId !== this.cachedTeamId || backlogId !== this.cachedBacklogId) {
            this.cachedTeamId = teamId;
            this.cachedBacklogId = backlogId;

            const parameters = {
                teamId,
                backlogId
            };

            const contributionService = this.pageContext.getService<IVssContributionService>("IVssContributionService");
            this.workItemDataPromise = contributionService.getDataAsync<BacklogLevelWorkItemData>(
                DataProviders.BacklogLevelWorkItemDataProvider,
                parameters,
                true
            );
        }

        return this.workItemDataPromise;
    }

    public getBacklogLevelWorkItemDataForIds(teamId: string, backlogId: string, workItemIds: number[]) {
        const parameters = {
            teamId,
            backlogId,
            workItemIds
        };

        const contributionService = this.pageContext.getService<IVssContributionService>("IVssContributionService");
        return contributionService.getDataAsync<BacklogLevelWorkItemData>(DataProviders.BacklogLevelWorkItemDataProvider, parameters, true);
    }
}

Services.add("IBacklogLevelWorkItemService", { serviceFactory: BacklogLevelWorkItemService });
